import { t } from "@lingui/core/macro";

export function RegrelloFormFieldEmptyValueNone() {
  return <span className="text-textPlaceholder">{t`None`}</span>;
}
